module.exports = __webpack_public_path__ + "static/media/comment-medical.19ec5f07.svg";